const About = () => {
    return (
        <div className='w-full bg-base-100 shadow-lg rounded-lg p-8'>
            <h2 className='card-title text-3xl text-bold mb-0'>
                About
            </h2>
            <p>
                Application that works with Github API. Work with context and reducers was practiced during the development.
            </p>
        </div>
    );
};

export default About;